<router-outlet></router-outlet>
<vl-loader></vl-loader>
<vl-modal></vl-modal>
<vl-notification></vl-notification>
